export const REM_HOME_PAGE_BREAKPOINT = 49.375
